<script>
  let { size = 5, title = '', class: className } = $props();
</script>

<svg
  width={size * 4}
  height={size * 4}
  viewBox="0 0 58 57"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={className}
>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M7.37486 34.5692H3.2373V30.8166H7.37486V25.1742H12.0932V30.8166H16.9904V34.5692H12.0932V43.7609C12.0932 45.4473 12.9233 47.0167 14.8617 47.0167C15.7737 47.0167 16.6477 46.8248 17.1808 46.4814L17.3332 50.541C16.2688 50.848 15.0902 51.0015 13.5707 51.0015C9.57978 51.0015 7.37486 48.5112 7.37486 44.6051V34.5692Z"
    fill="#646567"
  />
  <path
    d="M33.1807 35.0681C32.2686 34.646 31.2804 34.3409 29.721 34.3409C26.5659 34.3409 24.5514 36.8676 24.5514 40.5838C24.5514 44.2214 26.2613 47.0186 29.8352 47.0186C31.2785 47.0186 32.876 46.4814 33.75 46.0996L33.9785 50.3511C32.4971 50.8115 30.9758 51.0034 28.8851 51.0034C22.4608 51.0034 19.2314 46.5984 19.2314 40.5858C19.2314 34.88 22.5769 30.36 28.6947 30.36C30.7473 30.36 32.2306 30.5902 33.6358 31.0104L33.1807 35.0681Z"
    fill="#646567"
  />
  <path d="M42.567 21.8168H37.4736V50.541H42.567V21.8168Z" fill="#646567" />
  <path
    d="M52.5411 38.3584V37.3531C52.5411 35.705 51.7528 34.7957 50.041 34.7957C48.4911 34.7957 47.5791 35.8585 47.5791 37.238V38.3584H52.5411ZM46.7432 39.3157V37.3435C46.7432 35.3597 47.9599 33.7808 50.0029 33.7808C52.2269 33.7808 53.377 35.141 53.377 37.3435V39.3157H46.7432Z"
    fill="#646567"
  />
  <path d="M53.3789 31.3883H46.7451V32.3457H53.3789V31.3883Z" fill="#646567" />
  <path
    d="M47.9218 24.6082C47.6172 25.0783 47.4648 25.5848 47.4648 26.4462C47.4648 27.9887 48.5768 29.0132 50.0601 29.0132C51.6195 29.0132 52.6554 27.8832 52.6554 26.4942C52.6554 25.8342 52.5887 25.6615 52.5411 25.4217H50.5266V26.8299H49.7478V24.4644H53.198C53.3218 24.8289 53.4931 25.4601 53.4931 26.5038C53.4931 28.6199 52.1432 30.0281 50.0334 30.0281C47.9904 30.0281 46.6309 28.5336 46.6309 26.4942C46.6309 25.5176 46.7737 25.086 46.9641 24.5315L47.9218 24.6082Z"
    fill="#646567"
  />
  <path d="M53.3789 21.8148H46.7451V22.7722H53.3789V21.8148Z" fill="#646567" />
  <path
    d="M47.581 18.7797V20.8575H46.7432V15.7446H47.581V17.8224H53.3789V18.7797H47.581Z"
    fill="#646567"
  />
  <path
    d="M47.6381 12.7287L50.9264 14.0602V11.3972L47.6381 12.7287ZM46.7432 13.1968V12.1915L53.377 9.36743V10.4111L51.7033 11.0903V14.3652L53.377 15.0463V16.0516L46.7432 13.1968Z"
    fill="#646567"
  />
  <path d="M52.5411 4.65747V7.45277H46.7432V8.41012H53.3789V4.65747H52.5411Z" fill="#646567" />
  <path d="M53.3636 43.9144H46.7051V50.6235H53.3636V43.9144Z" fill="#97BF0D" />
</svg>
